import React, {Dispatch, useEffect, useState} from "react";
import {StateChannelChat} from "./ChannelChatWindow";
import {
    fetchPreviousMessagesConversation,
    setAllMessagesConsumed,
    setMessageOfConversation
} from "./utils";
import {getChatIdentifier} from "../Auth";
import {LoadingView} from "../components/Loading";
import {alert} from "../components/Alert";
import ScrollToBottomMessages from "./ScrollToBottomMessages";
import {useChatDispatch} from "./store";

type Props = {
    conversation: any;
    state: StateChannelChat;
    dispatch: Dispatch<any>;
    componentType?: string;
    showInput: boolean;
};

function ChannelChatMessages(props: Props) {
    const currentUser = getChatIdentifier();
    const chatDispatch = useChatDispatch();
    const {conversation, state, dispatch, showInput = true} = props;
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let testCurrentUser = {type: typeof currentUser, currentUser};
        if (testCurrentUser.type !== "string") {
            alert("Something bad happen. The app will reload.").then(() => {
                // @ts-ignore
                window.location.reload();
            });
        }
        if (conversation) {
            fetchPreviousMessagesConversation(conversation, 30)
                .then(({messages, hasPrevPage, lastIndex, previousIndex}) => {
                    dispatch({
                        type: "setInitialMessages",
                        messages: messages,
                        previousIndex: previousIndex,
                        hasPreviousPage: hasPrevPage,
                        lastIndex: lastIndex
                    });
                    setLoading(false);
                })
                .catch(error => {
                    setLoading(false);
                    console.error({fetchPreviousMessages: error});
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const abortController = new AbortController();
        if (conversation) {
            conversation.on("messageAdded", async (message) => {
                // @ts-ignore
                let newMessage = await setMessageOfConversation(message);
                dispatch({type: "messageAdded", message: newMessage});
                // @ts-ignore
                chatDispatch({type: "MESSAGE_ADDED_ACTIVE_CHANNEL", conversation: message.conversation});
                await setAllMessagesConsumed(conversation);
            });

            conversation.on("messageUpdated", async ({message}) => {
                // @ts-ignore
                if (message.sid && message.attributes["archived"] === true) {
                    dispatch({type: "messageRemoved", messageSid: message.sid});
                } else {
                    // @ts-ignore
                    let updatedMessage = await setMessageForChat(message);
                    dispatch({type: "messageUpdated", message: updatedMessage});
                }
            });

            conversation.on("messageRemoved", async message => {
                // @ts-ignore
                if (message.state.sid) {
                    // @ts-ignore
                    dispatch({type: "messageRemoved", messageSid: message.state.sid});
                }
            });
        }
        return () => {
            abortController.abort();
        };
    }, [dispatch, conversation, chatDispatch]);

    if (loading) {
        return <LoadingView containerHeight={"330px"}/>;
    }

    if (loading) {
        return <LoadingView containerHeight={"330px"}/>;
    }

    return (
        <ScrollToBottomMessages
            messages={state.messages}
            conversation={conversation}
            lastIndex={state.lastIndex}
            dispatch={dispatch}
            previousIndex={state.previousIndex}
            hasPreviousPage={state.hasPreviousPage}
            init={state.init}
            showInput={showInput}
        />
    );
}

export default ChannelChatMessages;
